/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
    "/v1/metrics/livestream": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["LivestreamMetricsController_postLivestreamMetrics_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/metrics/specialist": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["SpecialistMetricsController_postSpecialistMetrics_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/metrics/engagement": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["EngagementMetricsController_postEngagementMetrics_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/recordings/{recordingType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["RecordingsController_postRecordingSegment_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}/recordings/{recordingType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["RecordingsController_getRecordings_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}/recordings/{recordingType}/segments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["RecordingsController_getRecordingSegmentIds_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}/recordings/{recordingType}/segments/metadata": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["RecordingsController_getAllRecordingSegmentDetails_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/engagements/{engagementId}/recordings/{recordingType}/segments/{segmentId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["RecordingsController_getRecordingSegmentById_v1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
};
export type webhooks = Record<string, never>;
export type components = {
    schemas: {
        CameraSettings: {
            firmwareVersion?: string;
            batteryPercentage?: number;
            unmetPerformanceModeCriteria?: string[];
            monitoredPerformanceModeActive?: boolean;
            batteryCharging?: boolean;
            outdoorMonitoringEnabled?: boolean;
            pirLevel?: string;
            odLevel?: string;
            pirEnable?: boolean;
            nightVision?: string;
            statusLight?: string;
        };
        EventParams: Record<string, unknown>;
        StreamingUsers: {
            type_agent?: number;
            type_app?: number;
            type_webapp?: number;
        };
        LiveStreamVideoStats: {
            streamingUsers?: components["schemas"]["StreamingUsers"];
            jitter?: number;
            framesPerSecond?: number;
            cumulativeFreezeCount?: number;
            cumulativeFreezesDuration?: number;
            cumulativeStreamDuration?: number;
            cumulativePercentFrozen?: number;
            currentRoundTripTime?: number;
            currentBitrate?: number;
        };
        RawRtcStatsReport: {
            inboundRtp: Record<string, unknown>;
            candidatePair: Record<string, unknown>;
        };
        LiveStreamMetric: {
            milestoneName: string;
            /** Format: date-time */
            eventTimestamp: string;
            locationId?: number;
            userId: number;
            cameraUuid: string;
            cameraModel: string;
            cameraFwVersion: string;
            monitoringSpecialistId?: number;
            monitoringEngagementId?: string;
            /** Format: date-time */
            startTimestamp?: string;
            /** Format: date-time */
            endTimestamp?: string;
            bsFwVersion?: string;
            cameraSettings?: components["schemas"]["CameraSettings"];
            cameraConnectionType?: string;
            monitoringServiceProviderId?: string;
            subgzRssi?: string;
            cameraWifiRssi?: string;
            clientLiveStreamId?: string;
            streamType?: string;
            videoResolution?: string;
            eventParams?: components["schemas"]["EventParams"];
            reasonCode?: string;
            reasonDescription?: string;
            durationMs?: number;
            sourceApplication?: string;
            currentEngagementBlock?: string;
            sourceComponent?: string;
            liveStreamVideoStats?: components["schemas"]["LiveStreamVideoStats"];
            rawRtcStatsReport?: components["schemas"]["RawRtcStatsReport"];
        };
        SpecialistMetric: {
            /**
             * Format: date-time
             * @description ISO 8601 timestamp when the event occurred
             * @example 2023-10-01T12:00:00Z
             */
            eventTimestamp: string;
            milestoneName: string;
            sourceApplication: string;
            data: Record<string, unknown>;
        };
        EngagementMetric: {
            /**
             * Format: date-time
             * @description ISO 8601 timestamp when the event occurred
             * @example 2023-10-01T12:00:00Z
             */
            eventTimestamp: string;
            milestoneName: string;
            sourceApplication: string;
            engagementId: string;
            data: Record<string, unknown>;
        };
        RecordingSegmentMetadata: {
            segmentId: string;
            engagementIds: string[];
            /** Format: date-time */
            timestamp: string;
            sessionId: string;
            monitoringSpecialistId: string;
            recordingId?: string;
            sequenceNumber?: number;
            /** Format: date-time */
            recordingStartTime?: string;
        };
        RecordingSegment: {
            metadata: components["schemas"]["RecordingSegmentMetadata"];
            /** Format: binary */
            data: string;
        };
        StreamableFile: Record<string, unknown>;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
};
export type $defs = Record<string, never>;
export interface operations {
    LivestreamMetricsController_postLivestreamMetrics_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LiveStreamMetric"][];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    SpecialistMetricsController_postSpecialistMetrics_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SpecialistMetric"][];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    EngagementMetricsController_postEngagementMetrics_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EngagementMetric"][];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    RecordingsController_postRecordingSegment_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                recordingType: PathsV1EngagementsRecordingsRecordingTypePostParametersPathRecordingType;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["RecordingSegment"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    RecordingsController_getRecordings_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
                recordingType: PathsV1EngagementsRecordingsRecordingTypePostParametersPathRecordingType;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": components["schemas"]["StreamableFile"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    RecordingsController_getRecordingSegmentIds_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
                recordingType: PathsV1EngagementsRecordingsRecordingTypePostParametersPathRecordingType;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
        };
    };
    RecordingsController_getAllRecordingSegmentDetails_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
                recordingType: PathsV1EngagementsRecordingsRecordingTypePostParametersPathRecordingType;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RecordingSegmentMetadata"][];
                };
            };
        };
    };
    RecordingsController_getRecordingSegmentById_v1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                engagementId: string;
                recordingType: PathsV1EngagementsRecordingsRecordingTypePostParametersPathRecordingType;
                segmentId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/octet-stream": components["schemas"]["StreamableFile"];
                };
            };
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum PathsV1EngagementsRecordingsRecordingTypePostParametersPathRecordingType {
    web = "web",
    audio = "audio",
    video = "video"
}
